import { YesOrNo, YES_OR_NO_TRANSLATIONS } from '@pflegia/types/common/enums/yes-or-no.enum';

export {
  /** @deprecated import from @pflegia/types/common instead */
  YesOrNo,
  /** @deprecated import from @pflegia/types/common instead */
  YES_OR_NO_TRANSLATIONS,
};
